<template>
  <v-container grid-list-xl>
    <v-layout wrap justify-space-between>
      <v-flex xs12 md12>
        <v-alert :value="alert" type="success">Başarıyla kaydedildi.</v-alert>
      </v-flex>
      
      <!-- İndirim Temel Bilgileri -->
      <v-flex xs12 md6>
        <v-card class="pa-3" outlined>
          <v-card-title class="subtitle-1">İndirim Bilgileri</v-card-title>
          <v-text-field 
            v-model="mpDiscount.discountRate" 
            label="İndirim Oranı (%)" 
            required 
            type="number" 
            step="0.01"
            suffix="%"
          ></v-text-field>
          
          <v-layout row>
            <v-flex xs6>
              <v-date-picker 
                v-model="startDatePicker" 
                @input="onStartDateChange"
                locale="tr"
                class="mt-2"
              ></v-date-picker>
            </v-flex>
            <v-flex xs6>
              <v-date-picker 
                v-model="endDatePicker" 
                @input="onEndDateChange"
                locale="tr"
                class="mt-2"
              ></v-date-picker>
            </v-flex>
          </v-layout>
          
          <v-layout row>
            <v-flex xs6>
              <v-text-field
                v-model="startTime"
                label="Başlangıç Saati"
                type="time"
                @input="onStartTimeChange"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="endTime"
                label="Bitiş Saati"
                type="time"
                @input="onEndTimeChange"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <!-- Gün ve Ürün Seçimi -->
      <v-flex xs12 md6>
        <v-card class="pa-3" outlined>
          <v-card-title class="subtitle-1">Geçerlilik</v-card-title>
          
          <!-- Günler -->
          <v-card-text>
            <p class="subtitle-2">Geçerli Günler:</p>
            <v-layout row wrap>
              <v-flex xs3>
                <v-checkbox v-model="mpDiscount.monday" label="Pazartesi"></v-checkbox>
              </v-flex>
              <v-flex xs3>
                <v-checkbox v-model="mpDiscount.tuesday" label="Salı"></v-checkbox>
              </v-flex>
              <v-flex xs3>
                <v-checkbox v-model="mpDiscount.wednesday" label="Çarşamba"></v-checkbox>
              </v-flex>
              <v-flex xs3>
                <v-checkbox v-model="mpDiscount.thursday" label="Perşembe"></v-checkbox>
              </v-flex>
              <v-flex xs3>
                <v-checkbox v-model="mpDiscount.friday" label="Cuma"></v-checkbox>
              </v-flex>
              <v-flex xs3>
                <v-checkbox v-model="mpDiscount.saturday" label="Cumartesi"></v-checkbox>
              </v-flex>
              <v-flex xs3>
                <v-checkbox v-model="mpDiscount.sunday" label="Pazar"></v-checkbox>
              </v-flex>
              <v-flex xs3>
                <v-btn small @click="selectAllDays">Tümünü Seç</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>

          <!-- Ürün Kapsamı -->
          <v-card-text>
            <p class="subtitle-2">Ürün Kapsamı:</p>
            <v-radio-group v-model="mpDiscount.isAllProduct" @change="onProductScopeChange">
              <v-radio :value="true" label="Tüm Ürünler"></v-radio>
              <v-radio :value="false" label="Seçili Ürünler"></v-radio>
            </v-radio-group>
            
            <v-textarea
              v-if="!mpDiscount.isAllProduct"
              v-model="mpDiscount.productIds"
              label="Ürün ID'leri (virgülle ayrılmış)"
              hint="Örnek: 1,2,3,4"
              rows="3"
            ></v-textarea>
          </v-card-text>

          <!-- Durum -->
          <v-switch 
            v-model="mpDiscount.state" 
            :label="`Durum: ${mpDiscount.state ? 'Aktif' : 'Pasif'}`"
          ></v-switch>
        </v-card>
      </v-flex>
      
      <!-- Ana İndirim Bilgileri (Referans) -->
      <v-flex xs12 v-if="selectedMainDiscount && selectedMainDiscount.id">
        <v-card class="mt-4" outlined>
          <v-card-title class="subtitle-1">Ana İndirim Bilgileri (Referans)</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs3>
                <v-text-field v-model="selectedMainDiscount.discountRate" label="Ana İndirim Oranı" readonly suffix="%"></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field :value="formatDate(selectedMainDiscount.startDate)" label="Ana Başlangıç Tarihi" readonly></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field :value="formatDate(selectedMainDiscount.endDate)" label="Ana Bitiş Tarihi" readonly></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field :value="selectedMainDiscount.state ? 'Aktif' : 'Pasif'" label="Ana Durum" readonly></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      
      <v-flex xs12>
        <v-btn color="success" @click="saveMpDiscount" :loading="saveLoading">Kaydet</v-btn>
        <v-btn color="primary" @click="goBack" class="ml-2">Geri</v-btn>
        <v-btn v-if="!isEdit" color="info" @click="copyFromMainDiscount" class="ml-2">Ana İndirimden Kopyala</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    selectedMainDiscount: {},
    alert: false,
    saveLoading: false,
    isEdit: false,
    startDatePicker: null,
    endDatePicker: null,
    startTime: '00:00',
    endTime: '23:59',
    mpDiscount: {
      id: 0,
      discountRate: 0,
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      startTime: '00:00:00',
      endTime: '23:59:59',
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: true,
      sunday: true,
      state: true,
      productIds: '',
      isAllProduct: true
    }
  }),

  computed: {
    discountId() {
      return this.$route.params.id;
    }
  },

  async created() {
   
    await this.$store.dispatch("discounts/getAllDiscounts");
    
    if (this.discountId) {
      this.isEdit = true;
      await this.loadMpDiscount();
    } else {
      this.initializeNewDiscount();
    }
  },

  methods: {
    initializeNewDiscount() {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);

      this.mpDiscount = {
        id: 0,
        discountRate: 10,
        startDate: today.toISOString().substr(0, 10),
        endDate: tomorrow.toISOString().substr(0, 10),
        startTime: '00:00:00',
        endTime: '23:59:59',
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: true,
        sunday: true,
        state: true,
        productIds: '',
        isAllProduct: true
      };

      this.startDatePicker = this.mpDiscount.startDate;
      this.endDatePicker = this.mpDiscount.endDate;
      this.startTime = '00:00';
      this.endTime = '23:59';
    },

    async loadMpDiscount() {
      try {
        const mpDiscount = await this.$store.dispatch("mpDiscounts/getMpDiscount", this.discountId);
        this.mpDiscount = { ...mpDiscount };
        
      
        this.startDatePicker = new Date(mpDiscount.startDate).toISOString().substr(0, 10);
        this.endDatePicker = new Date(mpDiscount.endDate).toISOString().substr(0, 10);
        
      
        this.startTime = mpDiscount.startTime ? mpDiscount.startTime.substring(0, 5) : '00:00';
        this.endTime = mpDiscount.endTime ? mpDiscount.endTime.substring(0, 5) : '23:59';
        
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('MP Discount yüklenirken hata:', error);
      }
    },

    onStartDateChange() {
      this.mpDiscount.startDate = this.startDatePicker;
    },

    onEndDateChange() {
      this.mpDiscount.endDate = this.endDatePicker;
    },

    onStartTimeChange() {
      this.mpDiscount.startTime = this.startTime + ':00';
    },

    onEndTimeChange() {
      this.mpDiscount.endTime = this.endTime + ':59';
    },

    onProductScopeChange() {
      if (this.mpDiscount.isAllProduct) {
        this.mpDiscount.productIds = '';
      }
    },

    selectAllDays() {
      this.mpDiscount.monday = true;
      this.mpDiscount.tuesday = true;
      this.mpDiscount.wednesday = true;
      this.mpDiscount.thursday = true;
      this.mpDiscount.friday = true;
      this.mpDiscount.saturday = true;
      this.mpDiscount.sunday = true;
    },

    copyFromMainDiscount() {
     
      if (this.$store.state.discounts && this.$store.state.discounts.all && this.$store.state.discounts.all.length > 0) {
        const mainDiscount = this.$store.state.discounts.all[0]; // İlk ana indirimi al
        this.selectedMainDiscount = mainDiscount;
     
        this.mpDiscount.discountRate = mainDiscount.discountRate;
        this.mpDiscount.startDate = new Date(mainDiscount.startDate).toISOString().substr(0, 10);
        this.mpDiscount.endDate = new Date(mainDiscount.endDate).toISOString().substr(0, 10);
        this.mpDiscount.monday = mainDiscount.monday;
        this.mpDiscount.tuesday = mainDiscount.tuesday;
        this.mpDiscount.wednesday = mainDiscount.wednesday;
        this.mpDiscount.thursday = mainDiscount.thursday;
        this.mpDiscount.friday = mainDiscount.friday;
        this.mpDiscount.saturday = mainDiscount.saturday;
        this.mpDiscount.sunday = mainDiscount.sunday;
        this.mpDiscount.productIds = mainDiscount.productIds;
        this.mpDiscount.isAllProduct = mainDiscount.isAllProduct;
        
      
        this.startDatePicker = this.mpDiscount.startDate;
        this.endDatePicker = this.mpDiscount.endDate;
        this.startTime = mainDiscount.startTime ? mainDiscount.startTime.substring(0, 5) : '00:00';
        this.endTime = mainDiscount.endTime ? mainDiscount.endTime.substring(0, 5) : '23:59';
        this.onStartTimeChange();
        this.onEndTimeChange();
      }
    },

    async saveMpDiscount() {
      if (!this.mpDiscount.discountRate || this.mpDiscount.discountRate <= 0) {
        alert('İndirim oranı 0\'dan büyük olmalıdır!');
        return;
      }

      if (!this.mpDiscount.startDate || !this.mpDiscount.endDate) {
        alert('Başlangıç ve bitiş tarihleri zorunludur!');
        return;
      }

      if (new Date(this.mpDiscount.startDate) > new Date(this.mpDiscount.endDate)) {
        alert('Başlangıç tarihi bitiş tarihinden küçük olmalıdır!');
        return;
      }

  
      if (!this.mpDiscount.monday && !this.mpDiscount.tuesday && !this.mpDiscount.wednesday && 
          !this.mpDiscount.thursday && !this.mpDiscount.friday && !this.mpDiscount.saturday && !this.mpDiscount.sunday) {
        alert('En az bir gün seçilmelidir!');
        return;
      }

      this.saveLoading = true;
      try {
  
        this.onStartTimeChange();
        this.onEndTimeChange();
        
        if (this.isEdit) {
          await this.$store.dispatch("mpDiscounts/putMpDiscount", this.mpDiscount);
        } else {
          await this.$store.dispatch("mpDiscounts/postMpDiscount", this.mpDiscount);
        }
        
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
          this.goBack();
        }, 2000);
        
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Kaydetme hatası:', error);
        alert('Kaydetme sırasında hata oluştu!');
      } finally {
        this.saveLoading = false;
      }
    },

    goBack() {
      this.$router.push('/mpdiscount');
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('tr-TR');
    }
  },

  watch: {
    startDatePicker() {
      this.onStartDateChange();
    },
    endDatePicker() {
      this.onEndDateChange();
    }
  }
};
</script>
